import { AiOutlineHome } from 'react-icons/ai';
import { FiUsers, FiDollarSign, FiFileText, FiLock, FiBarChart2, FiUserPlus, FiSettings, FiUploadCloud, FiLink } from 'react-icons/fi';
import { MdOutlineInventory2, MdOutlineCategory, MdOutlineGroupWork, MdOutlineTune, MdOutlineViewCarousel } from 'react-icons/md';
import { IoBasketOutline, IoNewspaperOutline } from 'react-icons/io5';
import { HiOutlineUserGroup } from 'react-icons/hi';
import { TbChartLine } from 'react-icons/tb';
import { RiPriceTag3Line, RiShieldUserLine } from 'react-icons/ri';
import { FaWhatsapp } from 'react-icons/fa';
import { PERMISSIONS } from './permissions';

export const sidebarItems = [
  {
    label: 'Dashboard',
    icon: AiOutlineHome,
    path: '/dashboard',
    permission: PERMISSIONS.DASHBOARD_VIEW,
  },
  {
    label: 'Sales',
    icon: TbChartLine,
    permission: PERMISSIONS.MTD_BUSINESS_REPORT_VIEW,
    children: [
      {
        label: 'Sales Targets',
        icon: MdOutlineTune,
        path: '/sales/targets',
        permission: PERMISSIONS.SALES_RM_TARGETS_VIEW,
      },
      {
        label: 'Quarter Targets',
        icon: MdOutlineTune,
        path: '/sales/quarter-targets',
        permission: PERMISSIONS.SALES_RM_QUARTER_TARGETS_VIEW,
      },
      {
        label: 'MTD Business Report',
        icon: FiBarChart2,
        path: '/sales/mtd-business-report',
        permission: PERMISSIONS.MTD_BUSINESS_REPORT_VIEW,
      },
      {
        label: 'Sales Performance Report',
        icon: FiBarChart2,
        path: '/sales/performance-report',
        permission: PERMISSIONS.SALES_PERFORMANCE_REPORT_VIEW,
      },
      {
        label: 'YTD MIS Report',
        icon: FiBarChart2,
        path: '/sales/ytd-mis-report',
        permission: PERMISSIONS.YTD_MIS_REPORT_VIEW,
      },
      {
        label: 'Sales MIS Report',
        icon: FiBarChart2,
        path: '/sales/sales-mis-report',
        superAdminOnly: true,
      },
      {
        label: 'Order-wise Revenue',
        icon: FiBarChart2,
        path: '/sales/order-wise-revenue',
        permission: PERMISSIONS.ORDER_WISE_REVENUE_EXPORT,
      },
      {
        label: 'Offline Transactions',
        icon: FiFileText,
        path: '/sales/offline-sell-transactions',
        permission: PERMISSIONS.OFFLINE_PRODUCT_SALES_VIEW,
      },
    ],
  },
  {
    label: 'Investors',
    icon: FiUsers,
    permission: PERMISSIONS.INVESTORS_VIEW,
    children: [
      {
        label: 'Investor List',
        icon: FiBarChart2,
        path: '/investors/list',
        permission: PERMISSIONS.INVESTORS_LIST_VIEW,
      },
      {
        label: 'Onboard investor',
        icon: FiUserPlus,
        path: '/investors/onboard',
        permission: PERMISSIONS.INVESTORS_CREATE,
      },
    ],
  },
  {
    label: 'Partner',
    icon: HiOutlineUserGroup,
    permission: PERMISSIONS.PARTNER_VIEW,
    children: [
      {
        label: 'Partner List',
        icon: FiBarChart2,
        path: '/partners/list',
        activePaths: ['/partner/details/:partner_id'],
        permission: PERMISSIONS.PARTNER_LIST_VIEW,
      },
      {
        label: 'Onboard Partner',
        icon: FiUsers,
        path: '/partners/onboard',
        permission: PERMISSIONS.PARTNER_CREATE,
      },
    ],
  },
  {
    label: 'Pre-IPO',
    icon: MdOutlineCategory,
    permission: PERMISSIONS.PRODUCT_PRE_IPO_VIEW,
    children: [
      {
        label: 'Order Management',
        icon: FiBarChart2,
        path: '/pre-ipo/order-management',
        permission: PERMISSIONS.PRODUCT_PRE_IPO_ORDER_MANAGEMENT_VIEW,
      },
      {
        label: 'Shares Listing',
        icon: FiFileText,
        path: '/pre-ipo/listings',
        permission: PERMISSIONS.PRODUCTS_VIEW,
      },
      {
        label: 'Basket Order Management',
        icon: FiBarChart2,
        path: '/pre-ipo/basket-order-management',
        permission: PERMISSIONS.PRODUCT_PRE_IPO_ORDER_MANAGEMENT_VIEW,
      },
      {
        label: 'Basket Listings',
        icon: IoBasketOutline,
        path: '/pre-ipo/basket-management',
        permission: PERMISSIONS.PRODUCT_BASKET_LISTINGS_VIEW,
      },
      {
        label: 'Purchase Deal Sheet',
        icon: FiFileText,
        path: '/pre-ipo/purchase-deal-sheet',
        permission: PERMISSIONS.PRODUCT_PRE_IPO_PURCHASE_DEAL_SHEET_VIEW,
      },
      {
        label: 'Trade Commitments',
        icon: FiFileText,
        path: '/pre-ipo/trade-commitments',
        permission: PERMISSIONS.PRODUCT_PRE_IPO_TRADE_COMMITMENT_VIEW,
      },
      {
        label: 'Attributes',
        icon: MdOutlineCategory,
        path: '/pre-ipo/attribute-catalog',
        permission: PERMISSIONS.PRODUCTS_VIEW,
      },
      {
        label: 'New Shares Request',
        icon: FiFileText,
        path: '/pre-ipo/new-shares-request',
        permission: PERMISSIONS.PRODUCT_PRE_IPO_NEW_SHARES_REQUEST_VIEW,
      },
      {
        label: 'New Sell Request',
        icon: FiFileText,
        path: '/pre-ipo/new-sell-request',
        permission: PERMISSIONS.PRODUCT_PRE_IPO_NEW_SELL_REQUEST_VIEW,
      },
      {
        label: 'Reporting',
        icon: FiBarChart2,
        path: '/pre-ipo/reporting',
        permission: PERMISSIONS.PRODUCT_PRE_IPO_REPORTING_VIEW,
      },
    ],
  },
  {
    label: 'Inventory',
    icon: MdOutlineInventory2,
    permission: PERMISSIONS.PRODUCT_PRE_IPO_INVENTORY_VIEW,
    children: [
      {
        label: 'Dummy Inventory',
        icon: MdOutlineInventory2,
        path: '/pre-ipo/inventory',
        permission: PERMISSIONS.PRODUCT_PRE_IPO_INVENTORY_VIEW,
      },
      {
        label: 'Real Inventory',
        icon: MdOutlineInventory2,
        path: '/pre-ipo/real-inventory',
        permission: PERMISSIONS.PRODUCT_PRE_IPO_REAL_INVENTORY_VIEW,
      },
    ],
  },
  {
    label: 'Supplier',
    icon: MdOutlineGroupWork,
    path: '/supplier-masters',
    permission: PERMISSIONS.SUPPLIERS_VIEW,
  },
  // {
  //   label: 'Introducer',
  //   icon: FiUsers,
  //   path: '/introducer',
  //   permission: PERMISSIONS.INTRODUCER_VIEW,
  // },
  {
    label: 'Pricing',
    icon: RiPriceTag3Line,
    children: [
      {
        label: 'Pricing Groups',
        icon: FiDollarSign,
        path: '/pricing/groups',
        permission: PERMISSIONS.PRICING_GROUPS_VIEW,
      },
      {
        label: 'Product Slab Matrix',
        icon: FiDollarSign,
        path: '/pricing/product-slab-matrix',
        permission: PERMISSIONS.PRICING_SLAB_MATRIX_VIEW,
      },
      {
        label: 'Pricing Tiers',
        icon: FiDollarSign,
        path: '/pricing/special-tiers',
        permission: PERMISSIONS.PRICING_SPECIAL_TIERS_VIEW,
      },
      {
        label: 'Special Pricing Tiers',
        icon: FiDollarSign,
        path: '/pricing/special-product-tiers',
        permission: PERMISSIONS.PRICING_SPECIAL_PRODUCT_TIERS_VIEW,
      },
      {
        label: 'Special Price Requests',
        icon: FiDollarSign,
        path: '/pricing/special-pricing-requests',
        permission: PERMISSIONS.PRICING_SPECIAL_PRICING_REQUESTS_VIEW,
      },
      {
        label: 'Publish',
        icon: FiFileText,
        path: '/pricing/publish',
        permission: PERMISSIONS.PRICING_PUBLISH_VIEW,
      },
      {
        label: 'Share Price Chart',
        icon: TbChartLine,
        path: '/price-chart',
        permission: PERMISSIONS.PRICE_CHART_VIEW,
      },
    ],
  },
  // {
  //   label: 'Commissions',
  //   icon: FiDollarSign,
  //   path: '/commissions',
  //   permission: PERMISSIONS.COMMISSIONS_VIEW,
  // },
  {
    label: 'News',
    icon: IoNewspaperOutline,
    path: '/news',
    permission: PERMISSIONS.NEWS_VIEW,
  },
  {
    label: 'RBAC',
    icon: RiShieldUserLine,
    permission: PERMISSIONS.RBAC_VIEW,
    children: [
      {
        label: 'User Management',
        icon: FiUsers,
        path: '/rbac/user-management',
        permission: PERMISSIONS.RBAC_USER_MANAGEMENT_VIEW,
      },
      {
        label: 'Roles & Permissions',
        icon: FiLock,
        path: '/rbac/roles-permissions',
        superAdminOnly: true,
      },
      {
        label: 'Hierarchy',
        icon: MdOutlineGroupWork,
        path: '/rbac/hierarchy',
        permission: PERMISSIONS.RBAC_HIERARCHY_VIEW,
      },
    ],
  },
  {
    label: 'RA Referrals',
    icon: FiLink,
    path: '/investors/ra-referrals',
    permission: PERMISSIONS.RA_REFERRAL_VIEW,
  },
  {
    label: 'Configuration',
    icon: MdOutlineTune,
    permission: PERMISSIONS.CONFIGURATION_VIEW,
    children: [
      {
        label: 'Banners',
        icon: MdOutlineViewCarousel,
        path: '/config/banners',
        permission: PERMISSIONS.BANNERS_VIEW,
      },
      {
        label: 'Tracxn Upload',
        icon: FiUploadCloud,
        path: '/config/tracxn-upload',
        permission: PERMISSIONS.PRODUCTS_EDIT,
      },
    ],
  },
  {
    label: 'Settings',
    icon: FiSettings,
    permission: PERMISSIONS.SETTINGS_VIEW,
    children: [
      {
        label: 'WhatsApp Integration',
        icon: FaWhatsapp,
        path: '/settings/whatsapp',
        permission: PERMISSIONS.INTEGRATION_WHATSAPP_VIEW,
      },
      {
        label: 'Special WhatsApp Broadcast',
        icon: FaWhatsapp,
        path: '/settings/special-whatsapp-broadcast',
        superAdminOnly: true,
      },
      {
        label: 'Whatsapp Groups',
        icon: FiFileText,
        path: '/pricing/whatsapp-groups',
        permission: PERMISSIONS.PRICING_WHATSAPP_GROUPS_VIEW,
      },
      {
        label: 'Chatbot Contacts',
        icon: FiFileText,
        path: '/pricing/whatsapp-chatbot-contacts',
        permission: PERMISSIONS.PRICING_WHATSAPP_CHATBOT_VIEW,
      },
      {
        label: 'Business Team Alerts',
        icon: FiFileText,
        path: '/pricing/business-team-alerts',
        permission: PERMISSIONS.PRICING_BUSINESS_ALERTS_VIEW,
      },
    ],
  },
];
